var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.395996,
    width: 52,
    height: 52,
    rx: 15,
    fill: "#EBD96B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.875 34.396H17.4766V21.7163H20.875V34.396ZM17.2773 18.4351C17.2773 17.9272 17.4453 17.5093 17.7812 17.1812C18.125 16.853 18.5898 16.689 19.1758 16.689C19.7539 16.689 20.2148 16.853 20.5586 17.1812C20.9023 17.5093 21.0742 17.9272 21.0742 18.4351C21.0742 18.9507 20.8984 19.3726 20.5469 19.7007C20.2031 20.0288 19.7461 20.1929 19.1758 20.1929C18.6055 20.1929 18.1445 20.0288 17.793 19.7007C17.4492 19.3726 17.2773 18.9507 17.2773 18.4351Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.273 21.7163L27.3784 23.1812C28.2847 22.0483 29.4995 21.4819 31.023 21.4819C32.3667 21.4819 33.3667 21.8765 34.023 22.6655C34.6792 23.4546 35.0152 24.6343 35.0308 26.2046V34.396H31.6441V26.2866C31.6441 25.5679 31.4878 25.0483 31.1753 24.728C30.8628 24.3999 30.3433 24.2358 29.6167 24.2358C28.6636 24.2358 27.9487 24.6421 27.4722 25.4546V34.396H24.0855V21.7163H27.273Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.e36441e360ccd4bc3466cb67982a374d.svg";
export { ForwardRef as ReactComponent };